import React, { useEffect, useState } from 'react';
import LayoutComp from 'components/LayoutComp/Index';
import { BackArrow } from 'utils/svg';
import { STATIC_TEXT } from 'utils/constants';
import { Alert, Button, Card, Col, Form, Input, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updatePassword, updateProfile } from './account.action';
import Loader from 'components/ui/Loader';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 6
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 14
    }
  }
};

const AccountSettings = ({ history }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.userData);
  const userProfile = useSelector((state) => state.auth.userProfile);
  const accounts = useSelector((state) => state.accounts);
  const { loading = false, errorMsg = '' } = accounts;
  console.log('userData', userData);
  console.log('userProfile', userProfile);
  const { userFirstName = '', userLastName = '', emailId = '' } = userData;
  const [form] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const [isUserFormValid, setIsUserFormValid] = useState(true);
  const [isPasswordUpdateButtonDisabled, setIsPasswordUpdateButtonDisabled] = useState(true);

  useEffect(() => {
    form.setFieldsValue({
      firstName: userFirstName,
      lastName: userLastName,
      email: emailId
    });

    return () => form.resetFields();
  }, [userFirstName, userLastName, emailId, form]);

  const handleBack = () => {
    history.push('/');
  };

  const onFinish = (values) => {
    dispatch(updateProfile(values));
  };

  const handleUpdatePass = (values) => {
    const { currentPassword, newPassword } = values;
    const payload = {
      currentPassword,
      newPassword,
      email: emailId || ''
    };
    dispatch(updatePassword(payload));
  };

  const handleUserFormChange = () => {
    const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0);
    setIsUserFormValid(!hasErrors);
  };

  const handlePasswordFormChange = () => {
    const hasErrors = passwordForm.getFieldsError().some(({ errors }) => errors.length > 0);
    const hasEmptyRequiredFields = Object.values(passwordForm.getFieldsValue()).some(
      (value) => !value
    );

    setIsPasswordUpdateButtonDisabled(hasErrors || hasEmptyRequiredFields);
  };

  return (
    <LayoutComp history={history}>
      <div id="surveyType">
        <div className="back-nav">
          <div onClick={handleBack}>
            <BackArrow />
          </div>
          {STATIC_TEXT['MANAGE_ACCOUNT']}
        </div>
        <p className="sub-heading">{STATIC_TEXT['PROFILE_SUBHEADING']}</p>
      </div>
      <div className="accountsetting">
        {loading && <Loader />}
        <Row gutter={30}>
          <Col span={12}>
            <Card title="User Details">
              <Form
                form={form}
                {...formItemLayout}
                layout="horizontal"
                size="large"
                style={{ maxWidth: 600 }}
                onFinish={onFinish}
                autoComplete="off"
                onFieldsChange={handleUserFormChange}
              >
                <Form.Item
                  label="Email/Username"
                  name="email"
                  rules={[{ message: 'Please enter your email!' }]}
                >
                  <Input readOnly />
                </Form.Item>
                <Form.Item
                  label="First Name"
                  name="firstName"
                  rules={[{ required: true, message: 'Please enter your first name!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Last Name"
                  name="lastName"
                  rules={[{ required: true, message: 'Please enter your last name!' }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 8, span: 14 }}>
                  <Button type="primary" htmlType="submit" disabled={!isUserFormValid}>
                    Update
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Change Password">
              {errorMsg && <Alert message={errorMsg} type="error" />}
              <Form
                form={passwordForm}
                {...formItemLayout}
                layout="horizontal"
                size="large"
                style={{ maxWidth: 600 }}
                onFinish={handleUpdatePass}
                autoComplete="off"
                onFieldsChange={handlePasswordFormChange}
              >
                <Form.Item
                  label="Current Password"
                  name="currentPassword"
                  rules={[{ required: true, message: 'Please enter your current password' }]}
                >
                  <Input.Password placeholder="Enter your old password" />
                </Form.Item>
                <Form.Item
                  label="New Password"
                  name="newPassword"
                  rules={[
                    { required: true, message: 'Please enter your new password' },
                    {
                      pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
                      message:
                        'Password must be at least 6 characters long, contain one uppercase letter, one number, and one special character'
                    }
                  ]}
                >
                  <Input.Password placeholder="Enter your new password" />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirmpassword"
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Please confirm your new password' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('The two passwords do not match!'));
                      }
                    })
                  ]}
                >
                  <Input.Password placeholder="Confirm your new password" />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 8, span: 14 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={isPasswordUpdateButtonDisabled}
                  >
                    Update
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </LayoutComp>
  );
};

export default AccountSettings;
